<template>
  <el-dialog
    title="企业认证"
    v-if="DialogVisible"
    :visible.sync="DialogVisible"
    width="750px"
    class="large-padding-dialog"
    :close-on-click-modal="false"
    :before-close="Hide"
  >
    <el-form
      :model="DialogFormData"
      ref="DialogFormData"
      :rules="dialogRules"
      :class="[{ View: Type == 'View' }]"
      label-position="top"
    >
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item :label="l('企业类型')" prop="business_tag_id">
            <el-select
              v-model="DialogFormData.business_tag_id"
              :placeholder="l('请选择') + l('企业类型')"
              :disabled="Type == 'View'"
            >
              <el-option
                v-for="item of $store.state.basicInfo.tagList.business_1"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="企业名称" prop="name">
            <el-input
              v-model="DialogFormData.name"
              placeholder="请输入企业名称"
              :disabled="Type == 'View'"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <ResourceUpLoad
            label="营业执照"
            prop="business_license"
            usage="auth"
            :initResourceUrl.sync="DialogFormData.business_license"
            :disabled="Type == 'View'"
          />
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="Hide">{{ l("取 消") }}</el-button>
      <el-button type="danger" @click="refuse">驳回</el-button>
      <el-button
        v-if="DialogFormData.is_duplicate"
        type="success"
        @click="merge"
        >加入为子账户</el-button
      >
      <el-button v-else type="success" @click="verify">认证为主账户</el-button>
    </span>

    <RejectDialog ref="rejectDialog" @submitDialog="rejectCallback" />
  </el-dialog>
</template>

<script>
import dialogMixin from "@/assets/js/dialogMixin";

export default {
  name: "TenantAuth",
  mixins: [dialogMixin],
  data() {
    return {
      DialogFormData: {
        id: "",
        type: null,
        name: "",
        business_tag_id: "",
        business_license: "",
      },
      dialogRules: {
        name: [
          {
            required: true,
            message: this.l("请输入") + this.l("内容"),
            trigger: "blur",
          },
        ],
        business_tag_id: [
          {
            required: true,
            message: this.l("请选择") + this.l("企业类型"),
            trigger: "blur",
          },
        ],
        business_license: [
          {
            required: true,
            message: this.l("请上传") + this.l("照片"),
            trigger: "blur",
          },
        ],
      },
    };
  },

  methods: {
    BeforeShow() {
      return new Promise((resolve, reject) => {
        this.axios
          .get(`/api/admin_tenant_auth/${this.DialogFormData.id}/`)
          .then((response) => {
            this.DialogFormData = response;
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    verify() {
      this.$confirm(
        `是否通过【${this.DialogFormData.name}】审核，创建新的企业?`,
        "",
        {
          type: "warning",
        }
      ).then(() => {
        this.axios
          .put(`/api/admin_tenant_auth/${this.DialogFormData.id}/verify/`, {
            status: 1,
          })
          .then((data) => {
            this.$emit("submitDialog");
            this.Hide();
          });
      });
    },
    merge() {
      this.$confirm(
        `是否通过【${this.DialogFormData.name}】审核，加入该企业的子账户?`,
        "",
        {
          type: "warning",
        }
      ).then(() => {
        this.axios
          .put(`/api/admin_tenant_auth/${this.DialogFormData.id}/merge_sub/`)
          .then((data) => {
            this.$emit("submitDialog");
            this.Hide();
          });
      });
    },
    refuse() {
      this.$refs.rejectDialog.Show(
        Object.assign({}, this.DialogFormData, {
          dialogTitle: `驳回【${this.DialogFormData.name}】`,
        })
      );
    },
    rejectCallback(item) {
      this.axios
        .put(`/api/admin_tenant_auth/${this.DialogFormData.id}/verify/`, {
          status: 2,
          comment: item.comment,
        })
        .then((data) => {
          this.$emit("submitDialog");
          this.Hide();
        });
    },
  },
};
</script>


<style scoped lang="scss">
</style>

